import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { CommonLibModule } from 'common-lib';
import { WizardModule } from 'wizard';

import { AppComponent } from './app.component';
import { TabsComponent } from './tabs/tabs.component';
import { ShareComponent } from './tabs/share/share.component';
import { HelpComponent } from './tabs/help/help.component';
import { ScheduleComponent } from './tabs/schedule/schedule.component';
import { InsightsComponent } from './tabs/insights/insights.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { ErrorComponent } from './error/error.component';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { MicrosoftLegacyComponent } from './authentication/microsoft-legacy/microsoft-legacy.component';
import { ExchangeCardComponent } from './authentication/microsoft-legacy/exchange-card/exchange-card.component';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@app/core/core.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';

import { StringTimeToDatePipe } from './pipes/string-time-to-date.pipe';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ContextModule } from './modules/context/context.module';

@NgModule({
    declarations: [
        AppComponent,
        TabsComponent,
        ShareComponent,
        HelpComponent,
        ScheduleComponent,
        InsightsComponent,
        AuthenticationComponent,
        ErrorComponent,
        MicrosoftLegacyComponent,
        ExchangeCardComponent,
        StringTimeToDatePipe
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CommonLibModule,
        FormsModule,
        AuthenticationModule,
        ContextModule,
        CoreModule,
        WizardModule.forRoot(environment)
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
